import { faUsers } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Skeleton, Stack, Typography } from '@mui/material';

import { pluralize } from 'src/utils/intlUtils';

export interface CareZoneOptionLabelProps {
    name?: string;
    isLoadingMembersOnShift: boolean;
    membersOnShift: number;
}

export default function CareZoneOptionLabel(props: CareZoneOptionLabelProps) {
    const { name, isLoadingMembersOnShift, membersOnShift } = props;

    return (
        <Box data-dd-action-name={`${name} checkbox`}>
            <Typography
                variant="h5"
                sx={{
                    fontWeight: 'bold',
                    textTransform: 'capitalize',
                    mb: 0.5,
                }}
            >
                {name}
            </Typography>

            <Stack
                direction="row"
                sx={{
                    alignItems: 'center',
                    gap: 1.5,
                    color: membersOnShift === 0 ? 'red.900' : 'grey.700',
                }}
            >
                <FontAwesomeIcon icon={faUsers} />
                {isLoadingMembersOnShift ? (
                    <Skeleton animation="wave" height={21} width={120} />
                ) : (
                    <Typography variant="body1" sx={{ fontWeight: 'normal' }}>
                        {`${pluralize(membersOnShift, 'Member', 'Members')} on shift`}
                    </Typography>
                )}
            </Stack>
        </Box>
    );
}
